import React, { useEffect, useRef } from 'react';
export const Portfolio = () => {
  const companies = [{
    name: 'Databricks',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1754428735/Databricks_White_Large_cmbvsn.png',
    height: 61
  }, {
    name: 'Groq (Acq by Nvidia)',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ttK9tA93iuqza2yEHR6sMy/Groq_White_Large.png',
    height: 61,
    showExit: true
  }, {
    name: 'PLAY.AI',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8uSwFxeQJVkHBLPmcRuMPw/playai.png',
    height: 61,
    showExit: true
  }, {
    name: 'Goodnotes',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1754432034/Goodnotes_White_Logo_ov9hvp.png',
    height: 61
  }, {
    name: 'Vectara',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1754936326/Vectara_White_Large_st1oba.png',
    height: 61
  }, {
    name: 'Skypilot',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1754429401/Skypilot_White_Large_dimtjc.png',
    height: 61
  }, {
    name: 'Opaque',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1754428735/opaque_white_large_nos7uc.png',
    height: 61
  }];
  // Triple the companies array for seamless looping
  const allCompanies = [...companies, ...companies, ...companies];
  const carouselRef = useRef(null);
  useEffect(() => {
    const carousel = carouselRef.current;
    if (!carousel) return;
    const handleAnimationEnd = () => {
      carousel.style.animation = 'none';
      carousel.offsetHeight;
      carousel.style.animation = null;
    };
    carousel.addEventListener('animationend', handleAnimationEnd);
    return () => {
      carousel.removeEventListener('animationend', handleAnimationEnd);
    };
  }, []);
  return <section className="w-full pt-4 pb-8 px-6 md:px-12 bg-white overflow-visible transition-colors" data-id="element-70">
      <div className="max-w-7xl mx-auto" data-id="element-71">
        <div className="relative w-full overflow-visible" data-id="element-72">
          <style jsx data-id="element-73">{`
            @keyframes scroll {
              0% {
                transform: translateX(0);
              }
              100% {
                transform: translateX(calc(-100% / 3));
              }
            }
            .carousel {
              display: flex;
              width: fit-content;
              animation: scroll 30s linear infinite;
            }
          `}</style>
          <div ref={carouselRef} className="carousel" data-id="element-74">
            {allCompanies.map((company, index) => <div key={index} className="flex-shrink-0 px-4 md:px-8 w-[200px] md:w-[360px] h-[120px] flex items-center justify-center" data-id="element-75">
                <div className="relative w-full h-full flex items-center justify-center" data-id="element-76">
                  {company.showExit && <div className="absolute -top-3 right-0 px-2 py-1 border border-gray-400 rounded-md bg-white z-10" data-id="element-77">
                      <span className="text-gray-600 font-semibold text-[10px] tracking-wide" data-id="element-78">
                        EXIT
                      </span>
                    </div>}
                  <img src={company.logo} alt={`${company.name} logo`} className="max-w-full max-h-[60px] object-contain opacity-90 hover:opacity-100 transition-opacity" data-id="element-79" />
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
};